import React, { useState, useRef } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import config from '../../../../../../global/env.config';
import { API } from '../../../../../../vendor/api';
import { showNotification } from '../../../../../../store/features/notification/action-creators';
import { NotificationType } from '../../../../../../store/features/notification/types';
import { ResetButton } from './reset-button';
import './image-upload.scss';
export const ImageUpload = ({ imageType, institutionId, onUpload, onReset, showReset = false, uploadButtonId, resetButtonId, }) => {
    const intl = useIntl();
    const formatMessage = intl.formatMessage.bind(intl);
    const dispatch = useDispatch();
    const fileInputRef = useRef(null);
    const [isUploading, setIsUploading] = useState(false);
    const handleFileChange = async (e) => {
        const file = e.target.files?.[0];
        if (!file || institutionId === 0) {
            return;
        }
        setIsUploading(true);
        try {
            const formData = new FormData();
            formData.append('file', file);
            const params = new URLSearchParams({
                imageType,
                institutionId: institutionId.toString(),
            }).toString();
            const overrideSecret = localStorage.getItem('overrideSecret');
            const overrideIP = localStorage.getItem('overrideIP');
            const response = await fetch(`${config.apiUrl}/api/Storages/${config.s3config.waitingRoom}/upload?${params}`, {
                method: 'POST',
                headers: {
                    authorization: API.accessTokenId,
                    ...(overrideSecret &&
                        overrideIP && {
                        'x-override-secret': overrideSecret,
                        'x-override-ip': overrideIP,
                    }),
                },
                body: formData,
            });
            if (!response.ok) {
                // Try to parse error response to get specific error message
                let errorData = null;
                try {
                    errorData = await response.json();
                }
                catch {
                    // If parsing fails, throw generic error
                    throw new Error('Upload failed');
                }
                // Check if error is related to file size
                const errorMessage = errorData?.error?.message !== null &&
                    errorData?.error?.message !== undefined &&
                    typeof errorData.error.message === 'string'
                    ? errorData.error.message
                    : '';
                if (errorMessage !== '' &&
                    typeof errorMessage === 'string' &&
                    (errorMessage.includes('maxFileSize exceeded') ||
                        errorMessage.includes('maxFileSize'))) {
                    throw new Error('FILE_SIZE_ERROR');
                }
                throw new Error(typeof errorMessage === 'string' && errorMessage !== ''
                    ? errorMessage
                    : 'Upload failed');
            }
            const data = await response.json();
            const url = `${data.file.url}?${Date.now()}`;
            // Wait a bit before updating to ensure file is available
            setTimeout(() => {
                onUpload(imageType, url);
                setIsUploading(false);
                // Reset file input to allow selecting the same file again
                if (fileInputRef.current) {
                    fileInputRef.current.value = '';
                }
            }, 2000);
        }
        catch (error) {
            setIsUploading(false);
            // Reset file input to allow selecting the same file again after error
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
            // Check if error is related to file size
            const errorMessage = error instanceof Error ? error.message : String(error);
            const isFileSizeError = errorMessage === 'FILE_SIZE_ERROR' ||
                errorMessage.includes('maxFileSize exceeded') ||
                errorMessage.includes('maxFileSize');
            const notificationMessage = isFileSizeError
                ? formatMessage({
                    id: 'account.settings.clinic.branding.upload-error-file-size',
                })
                : formatMessage({
                    id: 'account.settings.clinic.branding.upload-error',
                });
            dispatch(showNotification(notificationMessage, NotificationType.ERROR));
        }
    };
    const handleClick = () => {
        fileInputRef.current?.click();
    };
    return (<div className="image-upload-wrapper">
      <input ref={fileInputRef} type="file" accept="image/*" onChange={(e) => {
            void handleFileChange(e);
        }} style={{ display: 'none' }}/>
      <div className="image-upload-controls">
        <button id={uploadButtonId} type="button" className="btn btn-primary progress-button md" onClick={handleClick} disabled={isUploading}>
          {isUploading ? (<FormattedMessage id="common.loading" defaultMessage="Uploading..."/>) : (<FormattedMessage id="account.settings.enterprise.theme.upload-btn"/>)}
        </button>
        {showReset && onReset && (<ResetButton onClick={onReset} resetButtonId={resetButtonId}/>)}
      </div>
    </div>);
};
